var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00024,
    y: 1,
    width: 33.9998,
    height: 34,
    rx: 16.9999,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4894 28.8378L7.2911 12.9058C6.62011 11.7434 7.45877 10.2908 8.80076 10.2908H27.1973C28.5393 10.2908 29.378 11.7434 28.707 12.9058L19.5087 28.8378C18.8377 30.0001 17.1604 30.0001 16.4894 28.8378Z",
    fill: "url(#paint0_linear_1144_26982)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9989 27.9421C17.7576 27.9421 17.5586 27.8271 17.4379 27.6181L8.82097 12.6931C8.7003 12.4841 8.7003 12.2541 8.82097 12.0454C8.94163 11.8364 9.14097 11.7214 9.38197 11.7214H26.6159C26.8572 11.7214 27.0562 11.8364 27.1769 12.0454C27.2976 12.2544 27.2976 12.4844 27.1769 12.6934L18.5599 27.6184C18.4393 27.8274 18.2399 27.9424 17.9989 27.9424V27.9421Z",
    fill: "url(#paint1_linear_1144_26982)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.999 21.4355V27.6248C17.8726 27.6248 17.7763 27.5692 17.7133 27.4598L9.09633 12.5345C9.03299 12.4252 9.03299 12.3142 9.09633 12.2048L14.457 15.2995L17.9993 21.4352L17.999 21.4355Z",
    fill: "url(#paint2_linear_1144_26982)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5412 15.2988L17.9989 21.4345L14.4565 15.2988H21.5412Z",
    fill: "url(#paint3_linear_1144_26982)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5412 15.2988L17.9989 21.4345L14.4565 15.2988H21.5412Z",
    fill: "url(#paint4_linear_1144_26982)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5583 15.9353H20.4397L17.999 20.163L15.5583 15.9353Z",
    fill: "url(#paint5_linear_1144_26982)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9016 12.2049L21.541 15.2999H14.4563L9.0957 12.2053C9.15904 12.0956 9.25504 12.0403 9.38137 12.0403H26.6153C26.7416 12.0403 26.838 12.0956 26.901 12.2049H26.9016Z",
    fill: "url(#paint6_linear_1144_26982)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9017 12.5345L18.2847 27.4598C18.2214 27.5692 18.1254 27.6248 17.999 27.6248V21.4355L21.5413 15.2998L26.902 12.2048C26.9653 12.3145 26.9653 12.4255 26.902 12.5348L26.9017 12.5345Z",
    fill: "url(#paint7_linear_1144_26982)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.00024,
    y: 1,
    width: 33.9998,
    height: 34,
    rx: 16.9999,
    stroke: "url(#paint8_linear_1144_26982)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1144_26982",
    x1: 7.05493,
    y1: 10.2908,
    x2: 29.2001,
    y2: 35.2619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB0AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1144_26982",
    x1: 8.73047,
    y1: 11.7214,
    x2: 27.1968,
    y2: 32.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1144_26982",
    x1: 9.04883,
    y1: 12.2048,
    x2: 24.4317,
    y2: 21.1372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7A73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1144_26982",
    x1: 18.9839,
    y1: 14.6605,
    x2: 15.6972,
    y2: 19.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#359D9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE495"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1144_26982",
    x1: 14.4565,
    y1: 15.2988,
    x2: 21.4315,
    y2: 23.3557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4238"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1144_26982",
    x1: 15.5583,
    y1: 15.9353,
    x2: 20.3644,
    y2: 21.4866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF847D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1144_26982",
    x1: 9.0957,
    y1: 12.0403,
    x2: 10.4216,
    y2: 19.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7A73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1144_26982",
    x1: 17.999,
    y1: 12.2048,
    x2: 33.3819,
    y2: 21.1372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7A73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1144_26982",
    x1: 0.000244141,
    y1: 0,
    x2: 41.3511,
    y2: 41.3668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB0AC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevel);
export default __webpack_public_path__ + "static/media/IconLevel.34addf24f678a0edcfada175e576377f.svg";
export { ForwardRef as ReactComponent };